import request from "@/utils/request";
export default {
    logout(data) {
        return request.get("/api/user/tel/logout/" + data)
    },
}